import { createSelector } from '@ngrx/store'

export const getExternalDashboardsSettingsState = createSelector(
  (state: any) => state.externalDashboardsSettings,
  (state: any) => state,
)
